export type SurveyRequestBody = {
  surveyType: BoltSurveyType
  totalScore: number
  questions: {
    order: number
    text: string
    answer: SurveyAnswer
  }[]
}

export type SurveyAnswer = {
  text?: string
  number?: number
  other?: string
}

export enum BoltSurveyType {
  PUSH_SURVEY = 'Push Survey'
}
